import {AfterViewInit, Component, HostListener, Inject, OnInit} from '@angular/core';
import {Router, NavigationEnd, ActivatedRoute} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {Title} from '@angular/platform-browser';
import {MainState} from '@nw/ui-core-shared/store/main.store';
import {Store} from '@ngrx/store';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { DOCUMENT } from '@angular/platform-browser';
import {fadeInOut} from '@nw/ui-core-shared/animations/animations';
import { EnvironmentService } from '@nw/ui-core-shared/services/environment.service';

@Component({
  selector: 'nw-root',
  templateUrl: './app.component.html',
  animations: [fadeInOut]
})

export class AppComponent implements OnInit, AfterViewInit {
  store$: Store<MainState>;
  isAuthenticating: Boolean = false;
  isFixedHeader: Boolean;
  isScrollingUp: Boolean;
  isAuthenticated: boolean = false;
  ifNavigatedToPage: boolean = false;
  error: object;
  auctionValue: object;
  conversationID: string;
  nwSsoToken: string;
  navigationPages = ['watchlist', 'vdp', 'search\/results', 'search', 'login', 'recommendations'];
  currentPage: {'currentPageName':string};
  private currentPageSubject$: Subject<{currentPageName: string}> = new Subject();
  private plIdSubject$: Subject<{plId: string}> = new Subject();
  public versionsOfModules: [{"module": string, "version": string}];

  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    // console.log('Back button pressed');
  }

  @HostListener('window:load', ['$event'])
  load(event) {

  }

  constructor(private translateService: TranslateService,
              private titleService: Title,
              private appStore: Store<MainState>,
              private router: Router,
              private environmentService: EnvironmentService,
              @Inject(DOCUMENT) private document: any) {
    // TODO: remove languageService after saving language to customer profile
    this.store$ = appStore;
    if(this.document.domain !== 'localhost' && this.environmentService.getEnvironment().stockWaveAppFlag && this.environmentService.getEnvironment().stockWaveAppFlag.set_document_domain_to) {
      this.document.domain = this.environmentService.getEnvironment().stockWaveAppFlag.set_document_domain_to;
    }
  }

  ngOnInit() {
    this.store$.select(state => state)
      .subscribe(mainState => {
        this._initApp(mainState.appPrincipal);
        this.isFixedHeader = mainState.appUiState.isFixedHeader;
        this.isScrollingUp = mainState.appUiState.isScrollingUp;
        this.error = mainState.appUiState.globalError;
        this.isAuthenticated = mainState.appPrincipal.isAuthenticated();
        this.conversationID = mainState.appPrincipal.getClassicRuntimeData().conversationId;
        this.nwSsoToken = mainState.appPrincipal.ssoToken;
      });

    // add className to loading page
    this.router.events
      .filter((event) => event instanceof NavigationEnd)
      .map((data: any) => {
        this.verifyNavigation(data['url']);
        return data
      })
      .subscribe((event) => {
        this.initAppLayout(this.router.url);
      });

    // set up page title base on private label ID
    Observable.combineLatest(
      this.currentPageSubject$,
      this.plIdSubject$
    ).switchMap(data => {
      let currentPageName = data[0].currentPageName;
      let plId = data[1].plId;
        if(currentPageName && plId) {
          return this.translateService.get('domainLookUp').map((domains) => {
            currentPageName = (currentPageName == "search\/results") ? "search-srp" : currentPageName;
            return domains[plId]['pageTitle'][currentPageName];
          })
        } if (!currentPageName && plId) {
          return this.translateService.get('domainLookUp').map((domains) => {
            return domains[plId]['pageTitle']['defaultTitle'];
          })
        }
      }).subscribe(translatedTitle => {
        this.titleService.setTitle(translatedTitle);
      });

    this.getVersions();
  }

  private _initApp(principal) {

    const plId = this.getPlId(principal.getClassicRuntimeData().plId);
    this.plIdSubject$.next({plId: plId});

    // TODO: remove languageService after saving language to customer profile
    // TODO: create plId mapping
    // only canadian site '29' is allowed to display fr lang
    const lang = (plId === '29') ? principal.language : 'en';

    document.querySelector('html').setAttribute('lang', lang);
    this.translateService.setDefaultLang(lang);
    this.translateService.use(lang);
  }

  getPlId(plId) {
    return (plId) ? plId : '1';
  }

  // TODO: remove the 'isAuthenticating' flag (not used)
  initAppLayout(curRouteUrl) {
    if (curRouteUrl.indexOf('login') >= 0) {
      this.isAuthenticating = true;
    } else {
      this.isAuthenticating = false;
      document.querySelector('body').classList.remove('init');
    }
  }

  ngAfterViewInit() {
    this.router.events
      .filter((event) => event instanceof NavigationEnd)
      .subscribe((event) => {
        // this.loadVdpFooterComponent(this.router.url);
      });
  }

  verifyNavigation(curRouteUrl) {
    this.ifNavigatedToPage = this.navigationPages.filter(page => curRouteUrl.indexOf(page) >= 0).length > 0;
    let currentPage =  this.navigationPages.filter((navigationPage: string) => {
      let pagePath = new RegExp(navigationPage, 'i');
      let verifiedCurrentPath = curRouteUrl.substring(0, 20).match(pagePath);
      if(verifiedCurrentPath && verifiedCurrentPath[0] == "search\/results") {
        return "search-srp";
      } else if(verifiedCurrentPath && verifiedCurrentPath[0] === "search") {
        return "search";
      } else {
        return verifiedCurrentPath;
      }
    });
    this.currentPage = {
      currentPageName : currentPage ? currentPage[0] : undefined
    };
    this.currentPageSubject$.next(this.currentPage);
  }

  getVersions() {
    this.versionsOfModules = this.environmentService.getEnvironment() && this.environmentService.getEnvironment().versions ?
      this.environmentService.getEnvironment().versions : [{"module": "modules not defined", "version": "versions not defined"}];

  }

  getStatusForUserSearchPermission (): boolean {
    return sessionStorage.getItem('isNWSearchEnabled') === 'true';
  }
}

/* istanbul ignore next */




// WEBPACK FOOTER //
// ./src/main/angular/app/app.component.ts